import { render, staticRenderFns } from "./FooterToTop.vue?vue&type=template&id=275455ad&scoped=true&lang=pug&"
import script from "./FooterToTop.vue?vue&type=script&lang=js&"
export * from "./FooterToTop.vue?vue&type=script&lang=js&"
import style0 from "./FooterToTop.vue?vue&type=style&index=0&id=275455ad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275455ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('275455ad')) {
      api.createRecord('275455ad', component.options)
    } else {
      api.reload('275455ad', component.options)
    }
    module.hot.accept("./FooterToTop.vue?vue&type=template&id=275455ad&scoped=true&lang=pug&", function () {
      api.rerender('275455ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/navigation/FooterToTop.vue"
export default component.exports